import { Inject } from '@angular/core';
import '@angular/compiler';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { ComponentReviewopsFinancialMetricCardComponent } from './component.reviewops.financial.metric.card/component.reviewops.financial.metric.card.component';
import { ComponentReviewopsIndustryClassificationComponent } from './component.reviewops.industry.classification/component.reviewops.industry.classification.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { ComponentReviewopsCompanySummaryComponent } from './component.reviewops.company.summary/component.reviewops.company.summary.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { ComponentReviewopsFinancialTrendChartComponent } from './component.reviewops.financial.trend.chart/component.reviewops.financial.trend.chart.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { ComponentReviewopsFinancialHealthScoreComponent } from './component.reviewops.financial.health.score/component.reviewops.financial.health.score.component';
import { ComponentReviewopsIndustryTaggingReviewComponent } from './component.reviewops.industry.tagging.review/component.reviewops.industry.tagging.review.component';
import { ComponentReviewopsDataQualityComponent } from './component.reviewops.data.quality/component.reviewops.data.quality.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { ComponentReviewopsRedFlagListComponent } from './component.reviewops.red.flag.list/component.reviewops.red.flag.list.component';
import { ComponentReviewopsInvestmentQuestionsComponent } from './component.reviewops.investment.questions/component.reviewops.investment.questions.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { ComponentReviewopsPeerComparisonComponent } from './component.reviewops.peer.comparison/component.reviewops.peer.comparison.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PortalSeasonLoadingDefaultComponent,
        PortalSeasonFormDropdownComponent,
        ComponentReviewopsFinancialMetricCardComponent,
        ComponentReviewopsIndustryClassificationComponent,
        PortalSeasonModalComponent,
        PortalPostDetailComponent,
        PagePostsItemComponent,
        ComponentReviewopsCompanySummaryComponent,
        PortalSeasonPaginationComponent,
        ComponentReviewopsFinancialTrendChartComponent,
        PageAccessComponent,
        PageMembersComponent,
        PagePostsComponent,
        PageDashboardComponent,
        ComponentReviewopsFinancialHealthScoreComponent,
        ComponentReviewopsIndustryTaggingReviewComponent,
        ComponentReviewopsDataQualityComponent,
        PortalPostListComponent,
        PageMypageComponent,
        PortalSeasonTreeComponent,
        ComponentReviewopsRedFlagListComponent,
        ComponentReviewopsInvestmentQuestionsComponent,
        ComponentNavSidebarComponent,
        ComponentReviewopsPeerComparisonComponent,
        LayoutSidebarComponent,
        LayoutEmptyComponent,
        PortalSeasonLoadingSeasonComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }